
//  replace certain characters with "The HTML Coded Character Set" 
export const sanitize = (str) => {
    if(!str) return str;
    return str.replace(/#/g, "&#35;").replace(/:/g, "&#58;").replace(/"/g, "&#34;");
}

// count words
export const countW = (str) => {
    if (str && str.length) return str.trim().split(/\s+/).length;
    return 0;
}

// count characters
export const countC = (str) => {
    if (str && str.length) return str.trim().length;
    return 0;
}
